import { LOG_IN } from '../../constants/ActionTypes';
import { getCookie } from '../../utils/trainUtils';
import { MMT_AUTH } from '../../constants/TrainConstants';

const INITIAL_STATE = {
  isLoggedIn: !!getCookie(MMT_AUTH),
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case LOG_IN: {
    return {
      ...state,
      isLoggedIn: action.payload,
    };
  }
  default:
    return state;
  }
};
